import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid2";
import { COLORS } from "../../constants/colors";

const classes = ({
  title: {
    fontSize: "20px",
    color: COLORS.white,
    paddingTop: "10px",
    paddingLeft: "20px",
    height: "40px",
  },
});
export const Title = (props) => {
  const { title } = props;
  return (
    <Grid item size={{xs:12}} sx={classes.title}>
      {`${title}`}
    </Grid>
  );
};

Title.propTypes = {
  title: PropTypes.string,
};
